import api from './client';

export interface SearchHit {
  id?: string;
  assetId?: string;
  label: string;
  sublabel: string | null;
  href: string;
}
export interface SearchResults {
  items: SearchHit[];
  units: SearchHit[];
  jobs: SearchHit[];
  clients: SearchHit[];
}

export const searchApi = {
  query: (q: string) =>
    api.get<SearchResults>('/search', { params: { q } }).then((r) => r.data),
};
